import React from 'react';

const ImageJs = (props) => (
    <svg {...props} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <circle id="path-1" cx="28" cy="28" r="28"/>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-280 -369)">
                <g transform="translate(120 189)">
                    <g transform="translate(54 180)">
                        <g transform="translate(106)">
                            <use fill="#60A9DD" xlinkHref="#path-1"/>
                            <use className="image-filter" fillOpacity="0.2" fill="#000" xlinkHref="#path-1"/>
                            <path d="M42.1262216,19.1290952 C41.1407756,19.6357476 39.9910886,19.9735159 38.8414016,20.057958 C39.9910886,19.2979793 40.8944141,18.1157902 41.3050166,16.6802749 C40.2374501,17.3558115 39.0056426,17.862464 37.6917146,18.2002323 C36.6241481,17.0180432 35.1459791,16.2580645 33.5035691,16.2580645 C30.38299,16.2580645 27.8372545,18.960211 27.8372545,22.3378941 C27.8372545,22.8445466 27.919375,23.266757 28.0014955,23.6889674 C23.2385065,23.4356411 19.0503609,20.9868209 16.2582639,17.3558115 C15.7655409,18.2846744 15.5191794,19.2979793 15.5191794,20.3957263 C15.5191794,22.5067783 16.5046254,24.364504 18.0649149,25.462251 C17.1615894,25.462251 16.2582639,25.1244827 15.5191794,24.7022723 L15.5191794,24.7867144 C15.5191794,27.7421871 17.4900714,30.1918518 20.1179274,30.7821019 C19.6252044,30.950986 19.1324814,31.0362725 18.6397584,31.0362725 C18.3112764,31.0362725 17.9006739,31.0362725 17.5721919,30.950986 C18.3112764,33.3998063 20.364289,35.1730899 22.9100245,35.1730899 C20.9391325,36.7774894 18.4755174,37.7916388 15.8476614,37.7916388 C15.3549384,37.7916388 14.9443359,37.7916388 14.4516129,37.7063523 C16.9973484,39.3951938 19.9536864,40.4084988 23.156386,40.4084988 C33.6678101,40.4084988 39.3341246,31.1198702 39.3341246,23.0978728 L39.3341246,22.3378941 C40.4016911,21.4090313 41.3871371,20.3957263 42.1262216,19.1290952"
                                fill="#FFF"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ImageJs;



// WEBPACK FOOTER //
// ./src/components/SocialMedium/assets/Twitter.js